import { useState } from "react";
import { Play } from "lucide-react";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "./ui/hover-card";

const VIDEO_ID = "rueOuC3fXGs";

export const VideoSection = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <section className="py-24" id="videos">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto mb-12">
          <div className="eyebrow eyebrow-dot mb-4 reveal">Background</div>
          <h2 className="section-title mb-3 reveal">What is a Code Blue?</h2>
          <p className="text-muted-foreground reveal">
            A quick explainer to align stakeholders on the scenario datasyteAI™ supports.
          </p>
        </div>
        <div className="flex justify-center">
          <div className="w-full max-w-5xl lg:translate-x-12">

            <HoverCard openDelay={300} closeDelay={100}>
              <HoverCardTrigger asChild className="block w-full">
                <div className="reveal w-full rounded-xl overflow-hidden shadow-elevated aspect-video cursor-pointer relative bg-muted">
                  {playing ? (
                    <iframe
                      src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?rel=0&modestbranding=1&autoplay=1`}
                      title="What is a Code Blue?"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                      className="w-full h-full"
                    />
                  ) : (
                    <button
                      type="button"
                      onClick={() => setPlaying(true)}
                      aria-label="Play video: What is a Code Blue?"
                      className="group absolute inset-0 w-full h-full"
                    >
                      <img
                        src={`https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`}
                        alt="What is a Code Blue? video thumbnail"
                        width={480}
                        height={360}
                        className="w-full h-full object-cover"
                        loading="lazy"
                        decoding="async"
                        onError={(e) => {
                          const img = e.currentTarget;
                          if (!img.dataset.fallback) {
                            img.dataset.fallback = "1";
                            img.src = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`;
                          }
                        }}
                      />

                      <span className="absolute inset-0 flex items-center justify-center bg-background/45 transition-colors group-hover:bg-background/25">
                        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary shadow-soft transition-transform group-hover:scale-110">
                          <Play className="h-7 w-7 text-primary-foreground" fill="currentColor" />
                        </span>
                      </span>
                    </button>
                  )}
                </div>
              </HoverCardTrigger>

              <HoverCardContent className="w-80 bg-card/95 backdrop-blur-sm border-primary/20">
                <div className="space-y-2">
                  <h4 className="text-sm font-semibold text-primary">Understanding Code Blue Events</h4>
                  <p className="text-sm text-muted-foreground">
                    A Code Blue is called when a patient experiences cardiac or respiratory arrest. This video explains the critical first minutes and why coordinated response is essential for survival.
                  </p>
                </div>
              </HoverCardContent>
            </HoverCard>
          </div>
        </div>
      </div>
    </section>
  );
};
